module.exports = __webpack_public_path__ + "img/dolphin.6a41dba9.svg";